import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a7b29a7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "animated-eyes" }

import {
  computed,
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AnimatedEyes',
  setup(__props) {

const leftEye = ref<HTMLDivElement>()
const rightEye = ref<HTMLDivElement>()
const leftPupil = ref({
  x: 0,
  y: 0,
})
const rightPupil = ref({
  x: 0,
  y: 0,
})

const MAX_OFFSET_X = 38
const MAX_OFFSET_Y = 14
const EASING_DIVISOR_X = 4
const EASING_DIVISOR_Y = 8

const leftPupilStyle = computed(() => ({
  transform: `translate(${leftPupil.value.x}px, ${leftPupil.value.y}px)`,
}))
const rightPupilStyle = computed(() => ({
  transform: `translate(${rightPupil.value.x}px, ${rightPupil.value.y}px)`,
}))

let rafId: number | undefined = undefined
let pendingEvent: MouseEvent | undefined = undefined

const sharedClamp = (a: number, b: number, max: number): [number, number] => {
  const maxAbs = Math.max(Math.abs(a), Math.abs(b))
  if (maxAbs <= max) {
    return [a, b]
  }
  const scale = max / maxAbs
  return [a * scale, b * scale]
}

const updateEyes = () => {
  rafId = undefined
  if (!pendingEvent || !leftEye.value || !rightEye.value) {
    return
  }
  const event = pendingEvent
  pendingEvent = undefined
  const leftRect = leftEye.value.getBoundingClientRect()
  const rightRect = rightEye.value.getBoundingClientRect()
  const leftRestX = leftRect.left + leftRect.width / 2
  const leftRestY = leftRect.top + leftRect.height * 0.45
  const rightRestX = rightRect.left + rightRect.width / 2
  const rightRestY = rightRect.top + rightRect.height * 0.45
  const rawLx = (event.clientX - leftRestX) / EASING_DIVISOR_X
  const rawRx = (event.clientX - rightRestX) / EASING_DIVISOR_X
  const rawLy = (event.clientY - leftRestY) / EASING_DIVISOR_Y
  const rawRy = (event.clientY - rightRestY) / EASING_DIVISOR_Y
  const [lx, rx] = sharedClamp(rawLx, rawRx, MAX_OFFSET_X)
  const [ly, ry] = sharedClamp(rawLy, rawRy, MAX_OFFSET_Y)
  leftPupil.value = {
    x: lx,
    y: ly,
  }
  rightPupil.value = {
    x: rx,
    y: ry,
  }
}

const handleMouseMove = (event: MouseEvent) => {
  pendingEvent = event
  if (rafId === undefined) {
    rafId = requestAnimationFrame(updateEyes)
  }
}

onMounted(() => {
  window.addEventListener('mousemove', handleMouseMove, {passive: true})
})

onBeforeUnmount(() => {
  window.removeEventListener('mousemove', handleMouseMove)
  if (rafId !== undefined) {
    cancelAnimationFrame(rafId)
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      ref_key: "leftEye",
      ref: leftEye,
      class: "eye"
    }, [
      _createElementVNode("div", {
        class: "eye__pupil",
        style: _normalizeStyle(_unref(leftPupilStyle))
      }, null, 4)
    ], 512),
    _createElementVNode("div", {
      ref_key: "rightEye",
      ref: rightEye,
      class: "eye"
    }, [
      _createElementVNode("div", {
        class: "eye__pupil",
        style: _normalizeStyle(_unref(rightPupilStyle))
      }, null, 4)
    ], 512)
  ]))
}
}

})